export const customFilterOptions = (options, state) => {
  const search = (state?.inputValue || "").toLowerCase().trim();

  if (!search) return options;

  const startsWith = [];
  const contains = [];

  options.forEach((option) => {
    if (!option) return;

    const name = typeof option.name === "string" ? option.name.toLowerCase() : "";
    const mobile = typeof option.mobile === "string" ? option.mobile.toLowerCase() : "";
    const ean = option.ean !== undefined && option.ean !== null ? String(option.ean).toLowerCase() : "";
    const plu = option.plu !== undefined && option.plu !== null ? String(option.plu).toLowerCase() : "";

    if (
      (name && name.startsWith(search)) ||
      (mobile && mobile.startsWith(search)) ||
      (ean && ean.startsWith(search)) ||
      (plu && plu.startsWith(search))
    ) {
      startsWith.push(option);
    } else if (
      (name && name.includes(search)) ||
      (mobile && mobile.includes(search)) ||
      (ean && ean.includes(search)) ||
      (plu && plu.includes(search))
    ) {
      contains.push(option);
    }
  });

  const sortByOrder = (a, b) => {
    const orderA = a.order ?? Infinity;
    const orderB = b.order ?? Infinity;
    if (orderA !== orderB) return orderA - orderB;
    return (a.name || "").localeCompare(b.name || "");
  };

  startsWith.sort(sortByOrder);
  contains.sort(sortByOrder);

  return [...startsWith, ...contains];
};
